(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('ConversationDetailController', ConversationDetailController);

    ConversationDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Conversation', 'Company', 'ServiceItem', 'PersonInfo', 'Message'];

    function ConversationDetailController($scope, $rootScope, $stateParams, previousState, entity, Conversation, Company, ServiceItem, PersonInfo, Message) {
        var vm = this;

        vm.conversation = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('tikonApp:conversationUpdate', function (event, result) {
            vm.conversation = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
